var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answers-page-customers"},[(!_vm.isMobileChecker)?_c('answersList',{attrs:{"listData":_vm.questionsPage.q_buyers}}):_c('answersListMobile',{attrs:{"listData":_vm.questionsPage.q_buyers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }